import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Else, If, Then } from "react-if";

// import HBCategorySelect from "../../components/HBCategorySelect";
// import FilterSelect from "@/components/FilterSelect";
import BoardList from "../../components/BoardList";

import { getSearchBoards } from "../../services";

import styles from "./index.module.less";

// import { SORT_LIST, SORT_ITEM_MAP } from "@/constants/sort";

export default function SearchBoardList({
  query,
  empty,
  searchResult,
  serverSideFacets,
  setCategoriesList,
}) {
  const pageRef = useRef(searchResult ? 2 : 1);
  const [hasMore, setHasMore] = useState(true);
  const [dataSource, setDataSource] = useState(searchResult || []);
  const [categories, setCategories] = useState(
    serverSideFacets
      ? serverSideFacets?.categories
          .filter((category) => serverSideFacets?.results[category.id])
          .map((category) => ({
            ...category,
            value: category.id,
          }))
      : []
  );
  const [busy, setBusy] = useState(false);
  const { q, category, sort } = query;

  const initRef = useRef(!searchResult);

  const queryAction = useMemo(() => {
    // 服务端渲染时，不做初始化的一些操作
    if (initRef.current) {
      pageRef.current = 1;
      setHasMore(true);
      setDataSource([]);
    } else {
      initRef.current = true;
    }

    return async () => {
      if (!q) {
        return;
      }

      // 设置如果超过30秒，显示服务器繁忙，请稍等片刻...
      const timer = setTimeout(() => {
        setBusy(true);
      }, 10000);
      const result = await getSearchBoards({
        q,
        ...(sort ? { sort: sort === "all" ? "all2" : sort } : null),
        ...(category ? { category } : null),
        page: pageRef.current,
        per_page: 20,
        hide_other_count: 1,
      });
      // 如果结果返回有问题直接设置繁忙，如果没问题就清楚定时器
      if (result?.err) {
        setBusy(true);
      } else {
        clearTimeout(timer);
        setBusy(false);
      }

      if (result.facets?.categories) {
        setCategories(
          result.facets?.categories
            .filter((category) => result.facets?.results?.[category?.id])
            .map((category) => ({
              ...category,
              value: category?.id,
            }))
        );
      }

      const boards = result?.boards || [];

      if (boards.length <= 0) {
        setHasMore(false);
      }
      setDataSource((dataSource) => dataSource.concat(boards));
    };
  }, [q, category, sort]);

  useEffect(() => {
    queryAction();
  }, [queryAction]);

  useEffect(() => {
    setCategoriesList((state) => {
      return { ...state, board: categories };
    });
  }, [categories, setCategoriesList]);

  const onLoadMore = useCallback(() => {
    pageRef.current += 1;
    queryAction();
  }, [queryAction]);

  return (
    <div className={styles.board}>
      <If condition={dataSource.length > 0 || hasMore}>
        <Then>
          <BoardList
            dataSource={dataSource}
            hasMore={hasMore}
            onLoadMore={onLoadMore}
            loadingContent={
              busy ? (
                <div className={styles.busy}>服务器繁忙，请稍等片刻...</div>
              ) : null
            }
          />
        </Then>
        <Else>{empty}</Else>
      </If>
    </div>
  );
}
